// AppContext.js
import React, { createContext, useState } from "react";

// Create the context
export const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
  const [userMe, setUserMe] = useState();
  const [meLoading, setMeLoading] = useState(false);

  return <AuthContext.Provider value={{ userMe, setUserMe, meLoading, setMeLoading }}>{children}</AuthContext.Provider>;
};
